import { pushEvent } from "@/lib/gtm";

// Never send phone numbers, draft keys, query strings or full redirect URLs.
export function magazinePageEvent(path: string, search: string) {
  const article = path.match(/^\/articles\/(mag_[A-Za-z0-9_]+)\/?$/);
  if (article) return { event: "magazine_article_view", article_id: article[1] };
  if (path === "/redirect") {
    const params = new URLSearchParams(search);
    const salon = params.get("hpb_salon_id") || "";
    const articleId = params.get("article_id") || "";
    if (!/^H\d+$/.test(salon)) return null;
    return { event: "magazine_redirect_view", hpb_salon_id: salon,
      ...(/^mag_[A-Za-z0-9_]+$/.test(articleId) ? { article_id: articleId } : {}) };
  }
  return null;
}

let lastPage: string | undefined;
export function captureMagazinePage() {
  if (!window.location.hostname.startsWith("magazine.")) return;
  if (new URLSearchParams(window.location.search).has("draft_key")) return;
  const page = window.location.pathname + window.location.search;
  if (page === lastPage) return;
  lastPage = page;
  const event = magazinePageEvent(window.location.pathname, window.location.search);
  if (event) { const { event: name, ...params } = event; pushEvent(name, params); }
}

export function trackMagazineCta(articleId: string, salonId: string) {
  if (new URLSearchParams(window.location.search).has("draft_key")) return;
  pushEvent("magazine_salon_cta_click", { article_id: articleId, hpb_salon_id: salonId });
}
